export function hasVisibleHtmlContent(value) {
    if (value === null || value === undefined) return false
    if (typeof value !== "string") return true
    const text = value
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .trim()
    return text !== ""
}
